<template>
  <div class="modal-duplicate-invoice">
    <div class="modal-head">
      <h4>DUPLICATING INVOICE {{ invoice.invoice_number }}</h4>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <label class="lb w150">Invoice Number:</label>
        <div class="inputs">
          <div class="custom-control custom-radio">
            <input type="radio" id="invoice-number-seq" v-model="invoiceNumber" class="custom-control-input" value="seq">
            <label class="custom-control-label" for="invoice-number-seq">Sequence (#{{ nextSequence }})</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="invoice-number-new" v-model="invoiceNumber" class="custom-control-input" value="new">
            <label class="custom-control-label" for="invoice-number-new">New</label>
          </div>
        </div>
      </div>
      <div class="form-row" v-if="invoice.job_id">
        <label class="lb w150">Job Number:</label>
        <div class="inputs">
          <div class="custom-control custom-radio">
            <input type="radio" id="job-number-keep" v-model="jobNumber" class="custom-control-input" value="keep">
            <label class="custom-control-label" for="job-number-keep">Keep {{ invoice.client.code }}{{ invoice.job_id }}</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="job-number-none" v-model="jobNumber" class="custom-control-input" value="none">
            <label class="custom-control-label" for="job-number-none">None</label>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-foot">
      <div class="btns btns-2">
        <button type="button" class="btn btn-outline-black" @click="duplicateInvoice">Duplicate</button>
        <button type="button" class="btn btn-outline-gray" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ServiceInvoice from '@/services/invoice'

export default {
  data () {
    return {
      invoiceNumber: 'seq',
      jobNumber: 'keep',
      state: ''
    }
  },
  props: ['invoice', 'on_job_view'],
  watch: {},
  computed: {
    ...mapState({
      sequenceCharacters: state => state.option.sequenceCharacters
    }),
    nextSequence: function(){
      let self = this, index = 0;
      if (self.invoice.sequence) {
        index = self.sequenceCharacters.indexOf(self.invoice.sequence) + 1;
      }
      return (self.invoice.parent_id?self.invoice.parent_id:self.invoice.id) + self.sequenceCharacters[index];
    }
  },
  created () {},
  mounted () {},
  methods: {
    init () {

    },
    duplicateInvoice () {
      let self = this;
      if ( self.state == 'processing' ) {
        return;
      }
      self.state = 'processing';
      ServiceInvoice.clone({ id: self.invoice.id, invoiceNumber: self.invoiceNumber, jobNumber: self.jobNumber }, invoice => {
        self.state = '';
        self.$notify({
          type: 'success',
          text: 'This invoice has been cloned. '
        });
        if (self.on_job_view) {
          self.$store.dispatch('ADD_JOB_INVOICE', invoice);
        } else {
          self.$router.push({
            name: 'invoice',
            params: {
              invoiceId: invoice.id
            }
          });
        }
        self.$emit('close');
      });
    }
  }
}
</script>
